import { render } from "./BaseCheckbox.vue?vue&type=template&id=16f501cf&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "../../assets/css/inputeo.css?vue&type=style&index=0&id=16f501cf&scoped=true&lang=css"
import "./BaseCheckbox.vue?vue&type=style&index=1&id=16f501cf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f501cf"]])

export default __exports__